const initialState = {
    tales: [],
    tale: null
};

const talesReducer = (state = initialState, action) => {
    switch (action.type) {
        case 'GET_TALES':
            return { ...state, tales: action.payload };
        case 'SEARCH_TALES':
            return { ...state, tales: action.payload };
        case 'CREATE':
            return { ...state, tales: [...state.tales, action.payload] };
        case 'UPDATE_TALE':
            return { 
                ...state, 
                tales: state.tales.map((tale) => 
                    tale._id === action.payload._id ? action.payload : tale
                ) 
            };
        case 'DELETE_TALE':
            return { 
                ...state, 
                tales: state.tales.filter((tale) => tale._id !== action.payload) 
            };
        case 'GET_TALE':
            return { ...state, tale: action.payload };
        case 'UPDATE_COMMENT':
            return {
                ...state,
                tale: state.tale?._id === action.payload.tale
                    ? {
                        ...state.tale,
                        comments: state.tale.comments?.map(comment =>
                            comment._id === action.payload._id ? action.payload : comment
                        )
                    }
                    : state.tale,
                tales: state.tales.map(tale =>
                    tale._id === action.payload.tale
                        ? {
                            ...tale,
                            comments: tale.comments?.map(comment =>
                                comment._id === action.payload._id ? action.payload : comment
                            )
                        }
                        : tale
                )
            };
        case 'DELETE_COMMENT':
            return {
                ...state,
                tales: state.tales.map((tale) => {
                    if (tale._id === action.payload.taleId) {
                        return {
                            ...tale,
                            comments: tale.comments.filter((comment) => comment._id !== action.payload.commentId)
                        };
                    }
                    return tale;
                })
            };
        default:
            return state;
    }
};

export default talesReducer;